<template>
  <div class="settleRules">
    <div class="head-box">
      <h4 class="c-flex c-flex-item">
        <div class="c-m-r-5">结算政策</div>
        <el-popover
          placement="right"
          trigger="hover"
          content="生成结算单时会匹配满足条件的结算政策"
        >
          <i class="el-icon-info f-s-12 c_gray" slot="reference"></i>
        </el-popover>
      </h4>
      <div class="c-flex">
        <el-input
          placeholder="请输入政策名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" class="m-l-10" @click="doNew">新增结算政策</el-button>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          :data="fpi.data"
          empty-text="暂无数据"
          height="calc(100% - 50px)"
          highlight-current-row
        >
          <c-table :fields="extFields">
            <template slot="state">
              <el-table-column prop="state" label="状态">
                <template slot-scope="scope">
                  <el-tag :type="scope.row.state == 1 ? '' : 'warning'">
                    {{ scope.row.state == 1 ? '已启用' : '已禁用' }}
                  </el-tag>
                </template>
              </el-table-column>
            </template>
            <template slot="endTime">
              <el-table-column label="政策失效时间" width="200px">
                <template slot-scope="scope">
                  {{ scope.row.endTime || '不限制' }}
                </template>
              </el-table-column>
            </template>
            <template slot="startTime">
              <el-table-column label="政策生效时间" width="200px">
                <template slot-scope="scope">
                  {{ scope.row.startTime || '不限制' }}
                </template>
              </el-table-column>
            </template>
            <template slot="calcTypeValue">
              <el-table-column label="扣减">
                <template slot-scope="scope">
                  <span v-if="scope.row.calcType == 0">{{ scope.row.calcTypeValue }}%</span>
                  <span v-else>{{ scope.row.calcTypeValue }}元</span>
                </template>
              </el-table-column>
            </template>
          </c-table>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)">编辑</el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="结算政策"
      :visible.sync="openDetail"
      width="900px"
      :close-on-click-modal="false"
    >
      <c-form
        :formData="formData"
        :fields="extFields"
        labelWidth="130px"
        @changeForm="osg.changeForm"
        :options="options"
        :error="true"
        ref="form"
        :rules="rules"
        label-width="130px"
        label-position="left"
      >
        <slot slot="deductType">
          <div style="margin:0 0 18px 130px;width:calc(100% - 130px) !important">
            <el-tag
              type="success"
              size="medium"
              style="max-width:90%;white-space: normal;word-break: break-all;height:auto;"
            >
              当超出“结算政策上限总额”时： 按照结算科目排序（支持拖拽排序），
              从上到下依次扣除科目上限总额，直至达到“结算政策上限总额”后不再扣除。
            </el-tag>
          </div>
          <draggable v-model="formData.deductType">
            <transition-group>
              <el-form-item
                v-for="(deductType, index) of formData.deductType"
                :key="index"
                :label="'结算科目' + (index + 1)"
                required
              >
                <div class="condition-card" style="cursor: move;">
                  <el-card shadow="hover">
                    <el-form-item label="科目名称" required>
                      <el-select
                        v-model="formData.deductType[index].subject"
                        placeholder="请选择结算科目"
                        filterable
                        default-first-option
                      >
                        <el-option
                          v-for="item in options.deductType"
                          :key="item.value"
                          :label="item.label"
                          :value="Number(item.value)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="计算方式" required>
                      <div class="c-flex">
                        <div>
                          <el-radio
                            :label="0"
                            v-model="formData.deductType[index].calcType"
                            @change="
                              delete formData.deductType[index].calcTypeValue;
                              $forceUpdate();
                            "
                          >
                            按比例
                          </el-radio>
                          <template v-if="formData.deductType[index].calcType == 0">
                            <el-input-number
                              v-model="formData.deductType[index].calcTypeValue"
                              :controls="false"
                              :min="0"
                              :precision="0"
                              placeholder="请输入比例"
                              style="border-radius: 3px 0 0 3px"
                            ></el-input-number>
                            %
                          </template>
                        </div>
                        <div style="margin-left:30px">
                          <el-radio
                            :label="1"
                            v-model="formData.deductType[index].calcType"
                            @change="
                              delete formData.deductType[index].calcTypeValue;
                              $forceUpdate();
                            "
                          >
                            按定额
                          </el-radio>
                          <template v-if="formData.deductType[index].calcType == 1">
                            <el-input-number
                              v-model="formData.deductType[index].calcTypeValue"
                              :controls="false"
                              :min="0"
                              :precision="0"
                              placeholder="请输入金额"
                            ></el-input-number>
                          </template>
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="科目上限总额" class="c-form-item-bottom-0">
                      <el-input
                        v-model="formData.deductType[index].toplimit"
                        :controls="false"
                        type="number"
                        placeholder="同一工单此科目累计最高结算金额，不填或填0均表示无上限"
                      ></el-input>
                    </el-form-item>
                  </el-card>
                  <div class="card-remove" v-if="formData.deductType.length > 1">
                    <i class="el-icon-remove" @click="removeDeductType(index)"></i>
                  </div>
                </div>
              </el-form-item>
            </transition-group>
          </draggable>
          <el-button
            plain
            icon="el-icon-plus"
            class="button_dashed"
            style="margin-left:130px"
            @click="newDeductType"
          >
            新增科目
          </el-button>
        </slot>
        <slot slot="conditions">
          <el-tag type="success" size="medium" style="margin:0 0 18px 130px">
            全部结算条件均满足时结算政策生效
          </el-tag>
          <el-form-item
            v-for="(condition, index) of formData.paramList"
            :key="index"
            :label="'补充条件' + (index + 1)"
          >
            <div class="condition-card">
              <el-card shadow="hover">
                <el-form-item label="单据">
                  <el-select
                    v-model="formData.paramList[index].colName"
                    placeholder="请选择"
                    @change="
                      formData.paramList[index].name = '';
                      formData.paramList[index].value = [];
                      getExtsFields(formData.paramList[index].colName);
                    "
                    filterable
                    default-first-option
                  >
                    <el-option
                      v-for="item in options.exts"
                      :key="item.colName"
                      :label="item.title"
                      :value="item.colName"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="字段">
                  <el-select
                    v-model="formData.paramList[index].name"
                    placeholder="请选择"
                    @change="
                      formData.paramList[index].value = [];
                      getOptions(formData.paramList[index].name);
                    "
                    filterable
                  >
                    <el-option
                      v-for="(item, i) in extsFields[formData.paramList[index].colName]"
                      :key="i"
                      :label="item.nameDisp"
                      :value="item.preset ? item.name : 'exts.' + item.name"
                      @click.native="
                        $set(formData.paramList[index], 'valueOption', item.valueOption);
                        $set(
                          formData.paramList[index],
                          'fieldType',
                          item.frontEndConfig.number ? 'number' : item.type
                        );
                        if (item.type == 'date' || item.type == 'datetime' || item.type == 'time') {
                          formData.paramList[index].valueType = 'between';
                          formData.paramList[index].value.push(null);
                        } else if (item.type == 'number' || item.type == 'digit') {
                          formData.paramList[index].valueType = 'between';
                        } else {
                          formData.paramList[index].valueType = 'contains';
                        }
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="过滤类型">
                  <el-select
                    v-model="formData.paramList[index].valueType"
                    placeholder="请选择"
                    @change="formData.paramList[index].value = []"
                    :disabled="
                      formData.paramList[index].fieldType == 'datetime' ||
                        formData.paramList[index].fieldType == 'date' ||
                        formData.paramList[index].fieldType == 'time'
                    "
                  >
                    <el-option label="包含" value="contains"></el-option>
                    <el-option label="区间" value="between"></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item
                  v-if="
                    formData.paramList[index].name && extsOptions[formData.paramList[index].colName]
                  "
                  label="值"
                  class="c-form-item-bottom-0"
                >
                  <el-cascader
                    v-if="formData.paramList[index].name == 'area'"
                    :props="area.props"
                    :options="area.options"
                    v-model="formData.paramList[index].value"
                    collapse-tags
                  ></el-cascader>

                  <el-select
                    v-else-if="
                      formData.paramList[index].name.endsWith('orgIds') ||
                        formData.paramList[index].name.endsWith('partnerIds') ||
                        formData.paramList[index].name.endsWith('productIds') ||
                        formData.paramList[index].name.endsWith('serviceTerritory')
                    "
                    v-model="formData.paramList[index].value"
                    multiple
                    filterable
                    clearable
                  >
                    <el-option
                      v-for="item in options[formData.paramList[index].name]"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>

                  <template v-else-if="formData.paramList[index].fieldType == 'cascade'">
                    <el-cascader
                      :options="
                        extsOptions[formData.paramList[index].colName][
                          formData.paramList[index].valueOption
                        ]
                      "
                      v-model="formData.paramList[index].value"
                      :props="{
                        multiple: true,
                        label: 'name',
                        emitPath: false
                      }"
                      clearable
                    ></el-cascader>
                  </template>

                  <template
                    v-else-if="
                      formData.paramList[index].fieldType == 'date' ||
                        formData.paramList[index].fieldType == 'datetime' ||
                        formData.paramList[index].fieldType == 'time'
                    "
                  >
                    <div
                      v-for="(item, i) in formData.paramList[index].value"
                      :key="i"
                      class="c-flex c-item-center"
                      style="margin-bottom: 18px"
                    >
                      <el-date-picker
                        v-if="
                          formData.paramList[index].fieldType == 'date' ||
                            formData.paramList[index].fieldType == 'datetime'
                        "
                        v-model="formData.paramList[index].value[i]"
                        :value-format="
                          formData.paramList[index].fieldType == 'date'
                            ? 'yyyy-MM-dd'
                            : 'yyyy-MM-dd HH:mm:ss'
                        "
                        :default-time="['00:00:00', '23:59:59']"
                        :type="formData.paramList[index].fieldType + 'range'"
                        :start-placeholder="
                          formData.paramList[index].fieldType == 'date' ? '开始日期' : '开始时间'
                        "
                        :end-placeholder="
                          formData.paramList[index].fieldType == 'date' ? '结束日期' : '结束时间'
                        "
                        class="c-flex-1"
                      ></el-date-picker>
                      <el-time-picker
                        v-else
                        v-model="formData.paramList[index].value[i]"
                        value-format="HH:mm:ss"
                        is-range
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        :default-value="new Date(0, 0, 0, 0, 0, 0)"
                        class="c-flex-1"
                      ></el-time-picker>
                      <div class="card-remove">
                        <i
                          class="el-icon-remove"
                          @click="formData.paramList[index].value.splice(i, 1)"
                        ></i>
                      </div>
                    </div>
                    <el-button
                      plain
                      icon="el-icon-plus"
                      class="button_dashed"
                      @click="formData.paramList[index].value.push(null)"
                    >
                      新增时间段
                    </el-button>
                  </template>

                  <template v-else-if="formData.paramList[index].valueType == 'between'">
                    <div class="c-flex c-flex-item">
                      <el-input-number
                        v-model="formData.paramList[index].value[0]"
                        :controls="false"
                        placeholder="最小值"
                        class="c-flex-1"
                      ></el-input-number>
                      <div class="c-m-v-10">至</div>
                      <el-input-number
                        v-model="formData.paramList[index].value[1]"
                        :controls="false"
                        placeholder="最大值"
                        class="c-flex-1"
                      ></el-input-number>
                    </div>
                  </template>

                  <!-- 服务等级数据需要过滤行政区划 -->
                  <el-select
                    v-else-if="formData.paramList[index].name.endsWith('serviceLevel')"
                    v-model="formData.paramList[index].value"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    placeholder="支持输入创建"
                  >
                    <template
                      v-for="item in extsOptions[formData.paramList[index].colName][
                        formData.paramList[index].valueOption
                      ]"
                    >
                      <el-option
                        v-if="
                          formData.regions && formData.regions.length > 0
                            ? formData.regions.indexOf(item.region) != -1
                            : true
                        "
                        :key="item.value"
                        :label="item.label"
                        :value="
                          formData.paramList[index].fieldType == 'number' ||
                          formData.paramList[index].fieldType == 'digit'
                            ? Number(item.value)
                            : item.value
                        "
                      ></el-option>
                    </template>
                  </el-select>

                  <el-select
                    v-else
                    v-model="formData.paramList[index].value"
                    multiple
                    clearable
                    filterable
                    allow-create
                    default-first-option
                    placeholder="支持输入创建"
                  >
                    <el-option
                      v-for="item in extsOptions[formData.paramList[index].colName][
                        formData.paramList[index].valueOption
                      ]"
                      :key="item.value"
                      :label="item.label"
                      :value="
                        formData.paramList[index].fieldType == 'number' ||
                        formData.paramList[index].fieldType == 'digit'
                          ? Number(item.value)
                          : item.value
                      "
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-card>
              <div class="card-remove" v-if="formData.paramList.length > 1">
                <i class="el-icon-remove" @click="removeCondition(index)"></i>
              </div>
            </div>
          </el-form-item>
          <el-button
            plain
            icon="el-icon-plus"
            class="button_dashed"
            style="margin-left:130px"
            @click="newCondition"
          >
            新增条件
          </el-button>
        </slot>
        <template #titleSlot="{ item }">
          <el-divider content-position="center">{{ item.nameDisp }}</el-divider>
        </template>
        <template slot="cardinalType">
          <el-radio-group v-model="formData.cardinalType">
            <el-radio
              :label="Number(item.value)"
              v-for="(item, i) in options.cardinalType"
              :key="i"
            >
              {{ item.label }}
            </el-radio>
          </el-radio-group>
        </template>
        <template slot="groovyScriptId">
          <el-select v-model="formData.groovyScriptId">
            <el-option
              v-for="item in options.groovyScript"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="datetimerange">
          <el-date-picker
            v-model="formData.datetimerange"
            type="datetimerange"
            range-separator="至"
            start-placeholder="政策生效日期"
            end-placeholder="政策截止日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
          ></el-date-picker>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import areajs from '../../resources/js/area.js';
export default {
  activated() {
    window.$this = this;
  },
  name: 'SettleRules',
  data() {
    window.$this = this;
    return {
      name: 'settleRule',
      tenantId: '',
      fpi: {},
      searchValue: '',
      openDetail: false,
      extFields: [],
      formData: {
        regions: [],
        deductType: [{ calcType: 0 }],
        paramList: [{ colName: '', name: '', value: [], valueOption: '', fieldType: '' }],
        order: 100, //优先级
        cardinalType: 0, //结算基数类型
        datetimerange: [] //政策有效时间范围
      },
      rules: this.$util.rules,
      options: {
        codecfg_type: { codeId: 'settleType' }, //结算对象
        codecfg_settleSourceType: { codeId: 'settleSourceType2' }, // 结算来源类型
        codecfg_deductType: { codeId: 'deductType' }, // 扣减科目
        codecfg_settleConditions: { codeId: 'settleConditions' },
        codecfg_partnerType: { codeId: 'partnerType' },
        codecfg_operator: { codeId: 'operator' },
        codecfg_cardinalType: { codeId: 'cardinalType' }, // 基数类型
        codecfg_settleItemOrder: { codeId: 'settleItemOrder' }, // 结算等级
        codecfg_regions: { codeId: 'regions' }
      },
      area: {
        props: {
          multiple: true
        },
        options: this.osg.areaList
      },
      exts: [],
      extsFields: {},
      extsOptions: {}
    };
  },
  mounted() {
    this.tenantId = JSON.parse(sessionStorage['entity']).tenantId;
    this.getGroovyScripts();
    // 查询表单字典项
    this.osg.getFields('settleRule', () => {
      this.osg.getFpi();
      this.getData();
    });
    this.getExts();
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        regions: [],
        deductType: [{ calcType: 0 }],
        paramList: [{ colName: '', name: '', value: [], valueOption: '', fieldType: '' }],
        order: 100, //优先级
        cardinalType: 0, //结算基数类型
        datetimerange: [], //政策有效时间范围
        exts: {}
      };
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'in:state|array-integer#and': '0,1',
        sortField: 'order',
        sortOrder: 'desc',
        'regex:name|string#or': this.searchValue
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('biz/settleRule/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
      this.$nextTick(() => {
        this.$refs.form &&
          this.$refs.form.$refs.formData &&
          this.$refs.form.$refs.formData.clearValidate();
      });
    },
    doEdit(row) {
      this.formData = row;
      this.$set(this.formData, 'datetimerange', [row.startTime, row.endTime]);
      this.getBillDateFields(true);
      for (let condition of row.paramList) {
        this.getExtsFields(condition.colName);
        this.getOptions(condition.name);
      }
      this.openDetail = true;
    },
    doSave() {
      if (this.osg.validate()) {
        if (this.formData.datetimerange && this.formData.datetimerange.length > 0) {
          this.formData.startTime = this.formData.datetimerange[0];
          this.formData.endTime = this.formData.datetimerange[1];
        } else {
          //不填默认起止时间
          this.formData.startTime = '2023-01-01 00:00:00';
          this.formData.endTime = '2123-01-01 00:00:00';
        }
        // 校验结算科目必填项
        for (let i = 0; i < this.formData.deductType.length; i++) {
          let deductType = this.formData.deductType[i];
          if (!deductType.subject && deductType.subject != 0) {
            this.osg.toast(`请选择结算科目${i + 1}的科目名称`);
            return;
          }
          if (!deductType.calcTypeValue && deductType.calcTypeValue != 0) {
            this.osg.toast(`请填写结算科目${i + 1}计算方式的值`);
            return;
          }
          // 以下字段后台要求存储字符串
          deductType.calcTypeValue = String(deductType.calcTypeValue);
          deductType.toplimit =
            deductType.toplimit || deductType.toplimit === 0 ? String(deductType.toplimit) : '';
        }
        // 校验结算条件必填项
        for (let i = 0; i < this.formData.paramList.length; i++) {
          let param = this.formData.paramList[i];
          if (!param.colName) {
            this.osg.toast(`请选择条件${i + 1}的表单`);
            return;
          }
          if (!param.name) {
            this.osg.toast(`请选择条件${i + 1}的结算条件`);
            return;
          }
          if (!param.value || param.value.length == 0) {
            this.osg.toast(`请至少选择1个条件${i + 1}的值`);
            return;
          }
          if (
            param.fieldType == 'date' ||
            param.fieldType == 'datetime' ||
            param.fieldType == 'time'
          ) {
            for (let j = 0; j < param.value.length; j++) {
              if (!param.value[j] || param.value[j].length == 0) {
                this.osg.toast(`条件${i + 1}的值 不能有空值`);
                return;
              }
            }
          }
        }

        this.osg.ajax(
          'biz/settleRule/upsert.do',
          { data: JSON.stringify(this.formData) },
          () => {
            this.osg.toast('保存成功');
            this.doInit();
            this.getData();
          },
          {
            noload: true
          }
        );
      }
    },
    doEnable(id) {
      this.osg.ajax(`biz/settleRule/enable/${id}.do`, null, () => {
        this.osg.toast('启用成功');
        this.getData();
      });
    },
    doDisable(id) {
      this.osg.ajax(`biz/settleRule/disable/${id}.do`, null, () => {
        this.osg.toast('禁用成功');
        this.getData();
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax(`biz/settleRule/remove/${id}.do`, null, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    // 新增科目
    newDeductType() {
      console.log(this.formData);
      this.formData.deductType.push({
        calcType: 0
      });
    },
    // 删除科目
    removeDeductType(index) {
      this.formData.deductType.splice(index, 1);
    },
    // 新增条件
    newCondition() {
      this.formData.paramList.push({
        colName: '',
        name: '',
        value: [],
        valueOption: ''
      });
    },
    // 删除条件
    removeCondition(index) {
      this.formData.paramList.splice(index, 1);
    },
    // 获取字典表
    getOptions(type) {
      if (type && type.indexOf('.') != -1) {
        type = type.split('.')[1];
      }
      if (type == 'orgIds') {
        this.getOrgs();
      } else if (type == 'partnerIds') {
        this.getPartners();
      } else if (type == 'productIds') {
        this.getProducts();
      } else if (type == 'serviceTerritory') {
        this.getST();
      } else if (type == 'area') {
        return;
      } else {
        return;
        // 字典表选项
        // if (type == 'channel' || type == 'repairParts') {
        //   this.options['cascadeCode_' + type] = {
        //     codeId: type
        //   };
        // } else {
        //   this.options['codecfg_' + type] = { codeId: type };
        // }
        // this.osg.codeoption(() => {
        //   this.$forceUpdate();
        // });
      }
    },
    // 获取服务区域
    getST(query) {
      this.osg.ajax(
        'basic/serviceTerritory/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          'regex:name|string#or': query,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.serviceTerritory = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 获取组织
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.orgList.map(item => {
            item.label = item.orgName;
            item.value = item._id;
          });
          this.options.orgIds = res.data.orgList;
          this.$forceUpdate();
        }
      );
    },
    // 获取伙伴
    getPartners() {
      this.osg.ajax(
        'basic/partner/query.do',
        {
          _all: '1',
          'in:state|array-integer#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.partnerIds = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 获取产品
    getProducts() {
      let params = {
        _all: '1',
        'in:state|array-integer#and': '1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };

      // 当选择指定门店时，指定产品只能选择门店可用的产品
      let paramList = this.formData.paramList;
      let orgIds = [];
      for (let item of paramList) {
        if (item.name == 'orgIds' && this.tenantId != '1340835581184723420') {
          orgIds.push(item.value);
        }
      }
      if (orgIds.length > 0) params['in:orgId|array#and'] = orgIds.toString();

      this.osg.ajax('basic/product/query.do', params, res => {
        res.data.map(item => {
          item.label = item.name;
          item.value = item._id;
        });
        this.options.productIds = res.data;
        this.$forceUpdate();
      });
    },
    //获取结算类型groovyScript
    getGroovyScripts() {
      this.osg.ajax(
        'groovyScript/query.do',
        {
          _all: '1',
          'is:type|integer#and': 2, //结算类型脚本
          'in:state|array-integer#and': '1',
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          res.data.map(item => {
            item.label = item.name;
            item.value = item._id;
          });
          this.options.groovyScript = res.data;
          this.$forceUpdate();
        }
      );
    },
    // 根据结算来源类型（工单、订单、合同），动态展示该对象中时间类型的字段
    getBillDateFields(edit) {
      // 清除原值（除编辑时）
      if (this.formData.billDateField && !edit) {
        this.formData.billDateField = '';
      }
      this.options.billDateFields = [];

      // 查询选项
      let colName;
      switch (this.formData.sourceType) {
        case 0:
          colName = 'serviceAppointment';
          break;
        case 1:
          colName = 'order';
          break;
        case 2:
          colName = 'contract';
          break;
        default:
      }
      if (colName) {
        this.osg.ajax(
          'biz/extField/query.do',
          {
            colName,
            _all: '1',
            'is:state|integer#and': 1,
            sortField: 'order',
            sortOrder: 'asc',
            'in:type|array#and': 'date,time,datetime'
          },
          res => {
            res.data.map(item => {
              item.label = item.nameDisp;
              item.value = item.name;
            });
            this.options.billDateFields = res.data;
            this.$forceUpdate();
          }
        );
      }
    },
    // 冗余存billDateField的中文名称
    billDateFieldChange(value) {
      this.formData.exts = this.formData.exts || {};
      let billDateFieldName = '';
      if (value) {
        let arr = this.options.billDateFields || [];
        for (let item of arr) {
          if (item.value == value) {
            billDateFieldName = item.label;
            break;
          }
        }
      }
      this.formData.exts.billDateFieldName = billDateFieldName || value;
    },
    getExts() {
      this.osg.ajax(
        'biz/ext/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:isSettle|string#and': '1',
          sortField: 'templateType,createTime',
          sortOrder: 'asc'
        },
        res => {
          this.options.exts = res.data;
        },
        { noload: true }
      );
    },
    getExtsFields(colName) {
      if (!colName || (this.extsFields[colName] && this.extsFields[colName].length > 0)) {
        return;
      }
      this.osg.getFields(
        colName,
        () => {
          this.$forceUpdate();
        },
        this,
        'extsFields.' + colName,
        null,
        null,
        {
          'nin:type|array#and':
            'file,title,gap,scan,button,evaluate,addItem,bgImage,pushItem,dialog,stepper,sendVerificationCode,canvas'
        },
        'extsOptions.' + colName
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.settleRules {
  .el-dialog__body {
    padding: 20px 30px;
  }
  .el-radio {
    display: inline !important;
  }
}
.calc-value {
  .el-form-item__content {
    display: flex;
  }
}
</style>
